import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import "../styles/auth.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return;

      const superAdminSnap = await getDoc(doc(db, "SuperAdmin", user.uid));
      const adminSnap = await getDoc(doc(db, "Admin", user.uid));

      if (superAdminSnap.exists() || adminSnap.exists()) {
        navigate("/dashboard");
      } else {
        await signOut(auth);
        setError("Access denied. You are not authorized.");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      const user = userCred.user;

      // 🔐 Check SuperAdmin
      const superAdminRef = doc(db, "SuperAdmin", user.uid);
      const superAdminSnap = await getDoc(superAdminRef);

      // 🔐 Check Admin
      const adminRef = doc(db, "Admin", user.uid);
      const adminSnap = await getDoc(adminRef);

      if (!superAdminSnap.exists() && !adminSnap.exists()) {
        // ❌ Not authorized
        await signOut(auth);
        setError("Access denied. You are not authorized.");
        return;
      }

      // ✅ Authorized → ensure profile exists
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        await setDoc(userRef, {
          email: user.email,
          createdAt: serverTimestamp(),
        });
      }

      navigate("/dashboard");
    } catch (err) {
      setError("Invalid login credentials.");
      console.error(err);
    }
  };

  return (
    <div className="login-wrapper">
      <form onSubmit={handleLogin} className="login-form">
        <h2 className="login-title">Sign In</h2>

        <input
          type="email"
          placeholder="Email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="error">{error}</p>}

        <button type="submit">Login</button>
      </form>
    </div>
  );
}
